
angular.module('dyb.page', ['duScroll', 'dybAuthentication']);
